<template>
  <div class="page">
    <van-list :error.sync="error" error-text="请求失败，点击重新加载" v-model="loading" :finished="finished" finished-text="已加载完毕"
              @load="loadData">
      <div @click="handleClick(item)" v-for="item in list" :key="item.id" class="app-card">
        <div class="content">
          <div class="content-item">
            <div>创建时间</div>
            <div>{{ item.createTime }}</div>
          </div>
          <div class="content-item">
            <div>申请状态</div>
            <div>{{ item.auditStatus | statusFilter }}</div>
          </div>
          <div class="content-item">
            <div>业务类型</div>
            <div>{{ item.businessType | businessTypeFilter }}</div>
          </div>
          <div class="content-item">
            <div>联系方式</div>
            <div>{{ item.contactInformation }}</div>
          </div>
          <div class="content-item">
            <div>备注信息</div>
            <div>{{ item.textMessage }}</div>
          </div>
          <template v-if="item.auditStatus != 0">
            <van-divider>审核信息</van-divider>
            <div class="content-item">
              <div>审核意见</div>
              <div>{{ item.auditFeedbackText || '无' }}</div>
            </div>
            <div class="content-item" v-if="item.auditFeedbackPictureUrl">
              <div>审核附件</div>
              <div><a :href="item.auditFeedbackPictureUrl"></a></div>
            </div>
          </template>
        </div>
      </div>
    </van-list>
    <div class="fixed-bottom"
         style="background: #fff;display: flex;flex-direction: row;flex-wrap: nowrap; justify-content: space-around;">
      <van-button
          style="width: 80%;"
          icon="plus" type="info" round
          @click="onClickCreate">发起新申请
      </van-button>
    </div>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>
<style scoped>
.page {
  box-sizing: border-box;
}


.content {
  display: flex;
  font-size: 14px;
  padding-top: 5px;
  flex-direction: column;
}

.content-item {
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 4px 20px;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
}
</style>
<script>
import {listAll} from '@/api/apply-list.js';
import nativeApi from '@/utils/native-bridge';
import BindPersonnel from '@/components/BindPersonnel';
import mixinLoad from '@/mixin/mixin-load.js';
import {checkService} from "@/api/user";

export default {
  name: 'ApplyList',
  components: {
    BindPersonnel
  },
  mixins: [mixinLoad],
  filters: {
    businessTypeFilter: function (value) {
      return ['生产', '流产', '上环等计生手术'][value - 1] || '';
    },
    statusFilter: function (value) {
      return ['草稿', '待审核', '审核通过', '审核不通过'][value] || '';
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      error: false
    };
  },
  methods: {
    onClickCreate() {
      this.$router.push({
        path: 'apply-detail'
      });
    },
    handleClick(item) {
      this.$router.push({
        path: '/apply-detail?id=' + item.id
      });
    },
    loadData() {
      this.loading = true;
      this.error = false;
      listAll()
          .then(({data}) => {
            this.list = data || [];
            this.loading = false;
            this.finished = true;
          })
          .catch(rep => {
            this.error = true;
            this.loading = false;
          });
    }
  },
  created() {
    // this.loadData();
    Promise.all([checkService('needResign'), this.preCheck()]).then(() => {

    })
  }
};
</script>
